import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import './AdminPages.css';

const FooterSettings = () => {
  const navigate = useNavigate();
  const [footer, setFooter] = useState({
    company_description: '',
    address: '',
    phone: '',
    email: '',
    social_links: '{"facebook": "", "twitter": "", "linkedin": ""}',
    copyright_text: ''
  });
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    fetchFooter();
  }, []);

  const fetchFooter = async () => {
    try {
      const response = await api.get('/admin/footer');
      // Convert social_links object to JSON string for textarea
      const footerData = {
        ...response.data,
        social_links: typeof response.data.social_links === 'object'
          ? JSON.stringify(response.data.social_links, null, 2)
          : response.data.social_links || '{"facebook": "", "twitter": "", "linkedin": ""}'
      };
      setFooter(footerData);
    } catch (err) {
      setError('Failed to load footer settings');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      await api.put('/admin/footer', footer);
      setSuccess('Footer settings saved as draft!');
      fetchFooter();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Failed to save footer settings');
    }
  };

  const handlePublish = async () => {
    try {
      await api.put('/admin/footer', footer);
      await api.post('/admin/footer/publish');
      setSuccess('Footer settings published!');
      fetchFooter();
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Failed to publish footer settings');
    }
  };

  if (loading) return <div className="loading">Loading...</div>;

  return (
    <div className="admin-page">
      <div className="container">
        <div className="page-header">
          <h1>Footer Settings</h1>
          <div className="button-group">
            <button onClick={() => navigate('/admin')} className="btn btn-secondary">
              Back to Dashboard
            </button>
            <button onClick={handlePublish} className="btn btn-success">
              Save & Publish
            </button>
          </div>
        </div>

        {success && <div className="success">{success}</div>}
        {error && <div className="error">{error}</div>}

        <div className="card">
          <h2>Company Information</h2>

          <div className="form-group">
            <label>Company Description</label>
            <textarea
              value={footer.company_description || ''}
              onChange={(e) => setFooter({ ...footer, company_description: e.target.value })}
              rows="4"
              placeholder="Brief description of your company..."
            />
          </div>

          <div className="form-group">
            <label>Address</label>
            <textarea
              value={footer.address || ''}
              onChange={(e) => setFooter({ ...footer, address: e.target.value })}
              rows="3"
              placeholder="123 Main Street, City, State 12345"
            />
          </div>

          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="tel"
              value={footer.phone || ''}
              onChange={(e) => setFooter({ ...footer, phone: e.target.value })}
              placeholder="+1 (555) 123-4567"
            />
          </div>

          <div className="form-group">
            <label>Email Address</label>
            <input
              type="email"
              value={footer.email || ''}
              onChange={(e) => setFooter({ ...footer, email: e.target.value })}
              placeholder="contact@yourcompany.com"
            />
          </div>

          <div className="form-group">
            <label>Social Media Links (JSON format)</label>
            <textarea
              value={footer.social_links || ''}
              onChange={(e) => setFooter({ ...footer, social_links: e.target.value })}
              rows="6"
              placeholder='{"facebook": "https://facebook.com/yourpage", "twitter": "https://twitter.com/yourhandle", "linkedin": "https://linkedin.com/company/yourcompany"}'
              style={{ fontFamily: 'monospace' }}
            />
            <small style={{ color: 'var(--secondary-color)' }}>
              Format: &#123;"platform": "url"&#125;
            </small>
          </div>

          <div className="form-group">
            <label>Copyright Text</label>
            <input
              type="text"
              value={footer.copyright_text || ''}
              onChange={(e) => setFooter({ ...footer, copyright_text: e.target.value })}
              placeholder="© 2025 Your Company. All rights reserved."
            />
          </div>

          <div className="button-group">
            <button onClick={handleSave} className="btn btn-primary">
              Save Draft
            </button>
            <button onClick={handlePublish} className="btn btn-success">
              Save & Publish
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterSettings;
